import script from "./Contact.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact.vue?vue&type=script&setup=true&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=070a7e76&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/wp-content/themes/stewartrealtor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070a7e76"]])

export default __exports__